// authorizedBuyers, openBidding, sdkBidding, googleAds, dv360
export const DEMAND_SOURCES = {
  AUTHORIZED_BUYERS: "authorizedBuyers",
  OPEN_BIDDING: "openBidding",
  SDK_BIDDING: "sdkBidding",
  GOOGLE_ADS: "googleAds",
  DV360: "dv360",
};

export const DEMAND_SOURCE_TYPE = {
  ALL: "all",
  SPECIFIC: "specific",
};
